import { TagColor } from './tag-color'

export class TagColorsUtil {

  public static COLOR_CLASS_PREFIX: string = 'se-tag__content--'

  public static getDefaultColor(): TagColor {
    return TagColor.Primary
  }

  public static isValid(color: string): boolean {

    for (const validColor in TagColor) {
      if (TagColor[validColor] === color) {
        return true
      }
    }

    return false

  }

  public static getAllValues(): string[] {

    const result: string[] = []

    for (const validColor in TagColor) {
      result.push(TagColor[validColor])
    }

    return result

  }

}
